import { makeStyles } from "@material-ui/core";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { getHotspotsObject, getSpinURL } from "../../redux/selectors";

const useStyles = makeStyles((theme) => ({
  // make viewer occupy whole available screen height (but not more)
  // see MUI default theme docs (search theme.mixins.toolbar) for details
  viewerContainer: Object.fromEntries(
    Object.entries(theme.mixins.toolbar).map(([k, v]) => {
      if (k === "minHeight") {
        return ["height", `calc(100vh - ${v}px)`];
      } else {
        return [k, { height: `calc(100vh - ${v.minHeight}px)` }];
      }
    })
  ),
}));

export function SirvMediaViewerContainer() {
  const classes = useStyles();
  const spinUrl = useSelector(getSpinURL);
  const hotspots = useSelector(getHotspotsObject);
  const SMVPayload = hotspots;
  const viewerRef = useRef(null);
  useEffect(() => {
    window.Sirv.on("spin:ready", (spin) => {
      const instance = window.Sirv.getInstance(viewerRef.current);
      if (!instance) {
        return;
      }
      instance.child(0).spin.hotspots.removeAll(); // Just in case we figure how not to rerender the viewer when we switch between steps
      SMVPayload.forEach((el) => {
        instance.child(0).spin.hotspots.add(el);
      });
    });
  });
  return (
    <div className={classes.viewerContainer}>
      <div
        className={["Sirv", classes.viewerContainer].join(" ")}
        id="smv"
        ref={viewerRef}
      >
        <div data-src={spinUrl}></div>
      </div>
    </div>
  );
}
